// extracted by mini-css-extract-plugin
export var icon = "_6q-1";
export var subtext = "_6q-0";